"use strict";

import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.js-brandnamic-dynform', (element) => {
        const config = {
            preset: element.getAttribute('data-dynform-preset'),
            version: element.getAttribute('data-dynform-version') || '3.0',
            lang: element.getAttribute('data-dynform-lang'),
        };

        const script = document.createElement('script');
        script.id = 'BN-dynform-v3-js';
        script.src = 'https://admin.ehotelier.it/js/dynform-v3/v3.0/dynform.js';
        script.setAttribute('data-cookieconsent', 'ignore');
        element.parentElement.appendChild(script);

        waitForBN(element, config);
    });
}

function waitForBN(element, config, attempts = 0) {
    if (window.BN?.DynFormsV3) {
        window.BN.DynFormsV3.init(element, config);
    } else if (attempts < 50) {
        setTimeout(() => waitForBN(element, config, attempts + 1), 100);
    }
}
